import React, { Component } from 'react';
import { Table, Button, Tag } from 'antd';
import styles from './AdminUsers.module.scss';
import UserInfo from '../../components/UserInfo';
import { USER_ROLES } from '~constants/users';

const { Column } = Table;
const { USER } = USER_ROLES;

class AdminUsers extends Component {
  componentWillMount() {
    this.props.listUsers();
  }

  renderRole = role => (
    <span>
      <Tag color={role === USER ? 'geekblue' : 'volcano'}>{role}</Tag>
    </span>
  );

  renderStatus = status => <Tag className={status.toLowerCase()}>{status}</Tag>;

  renderActions = (id, { role }) => (
    <span>
      <Button size="small" onClick={() => this.props.showUser(id)}>
        INFO
      </Button>
      {role === USER && (
        <Button
          size="small"
          type="danger"
          onClick={() => this.props.grantAdmin(id)}
        >
          Grant Admin
        </Button>
      )}
    </span>
  );

  render() {
    const { loading, list } = this.props;
    return (
      <div className={styles.table}>
        <UserInfo />
        <Table
          rowKey="id"
          size="small"
          loading={loading}
          dataSource={list}
          pagination={false}
          showHeader={false}
        >
          <Column title="email" dataIndex="email" />
          <Column title="role" dataIndex="role" render={this.renderRole} />
          <Column
            title="status"
            dataIndex="status"
            render={this.renderStatus}
          />
          <Column title="actions" dataIndex="id" render={this.renderActions} />
        </Table>
      </div>
    );
  }
}

export default AdminUsers;
